// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Qihj","content":"LayoutSettings_content__1pu-x"};